var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    viewBox: "0 0 21 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.727 3.394a1.5 1.5 0 1 0-2.121-2.121zM7.333 13.667l-1.06 1.06 1.06 1.061 1.061-1.06zM3.061 7.273A1.5 1.5 0 1 0 .939 9.394zm14.545-6L6.273 12.606l2.121 2.121L19.727 3.394zM8.394 12.606 3.061 7.273.939 9.394l5.334 5.333z"
  })));
};
export default SvgCheck;